<template>
  <div class="modal">
    <div slot="top-right"></div>
    <div class="modal__body">
      <img :src="require(`@/assets/img/work/${data.img}`)" />
      <div class="modal__body--content">
        <a class="modal__body--content--title" :href="data.link">
          {{
          data.name
          }}
        </a>
        <p>{{ data.desc }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Modalv2",
  props: ["data"]
};
</script>

<style lang="scss">
.v--modal-overlay.scrollable {
  background: rgba(0, 0, 0, 0.8);
}
.modal {
  height: auto;
  font-size: 24px;
  z-index: 2;

  &__body {
    font-family: $font-serif;
    &--content {
      padding: 5%;

      &--title {
        font-family: $font-sans;
        font-weight: bold;
        font-size: 32px;
        margin: 15px 0;
        color: rgba(black, 0.5);
        display: block;
        &:hover {
          text-decoration: underline;
          color: black;
        }
      }
    }

    img {
      max-width: 600px;
      height: auto;
      @media (max-width: 700px) {
        max-width: 500px;
      }
    }
  }
}
</style>
